export type OverlayCallback = () => void;

export const Overlay = {
	callback: () => {},
	el: document.getElementById( 'overlay' ) ?? null,

	init(): void {
		this.bindClass();
		this.bindEvents();
	},

	bindClass(): void {
		this.close = this.close.bind(this);
		this.open  = this.open.bind(this);
	},

	bindEvents(): void {
		this.el?.addEventListener( 'click', this.close );
	},

	close(): void {
		document.documentElement.classList.remove('overlay--open');

		this.callback();
		this.reset();
	},

	open(callback: OverlayCallback = () => {}): void {
		document.documentElement.classList.add('overlay--open');

		this.callback = callback;
	},

	reset(): void {
		this.callback = () => {};
	}
};
